<template>
  <div>
    <header-applis titre="Engager le financement" sous-titre="Vous êtes dans une autre situation" index-progression-courante="4"/>
    <div class="wrapper__content">
      <ul>
        <li>
          <p>Si vous ne l’avez pas encore fait,</p>
          <ul>
            <li>identifiez votre opérateur Conseil en Évolution Professionnelle (CEP) : <a href="https://www.mon-cep.org/" target="_blank">www.mon-cep.org</a>,
              et prenez contact avec lui.
            </li>
            <li>consultez vos droits sur : <a href="https://www.moncompteformation.gouv.fr/espace-prive/" target="_blank">www.moncompteformation.gouv.fr/espace-prive/</a></li>
            <li>cependant, si vous envisagez un contrat en alternance (apprentissage, professionnalisation) et que le diplôme permet cette possibilité, vous pourrez joindre directement le service de formation indiqué</li>
          </ul>
        </li>
      </ul>
    </div>
    <footer-applis ecran-precedent="choixstatutfinancement" ecran-suivant="fin" label-suivant="Terminer"/>
  </div>
</template>

<script>
import HeaderApplis from '../../components/HeaderApplis';
import FooterApplis from '../../components/FooterApplis';

export default {
  name: 'autresituationfinancement',
  components: {
    FooterApplis,
    HeaderApplis
  }
}
</script>
